<template>
    <div class="order_index">
        <el-container>
            <el-aside style="width: 200px">
                <ul class="left_url_tab">
                    <template v-for="menu in leftMenu" >
                        <li class="li-title_1">{{menu.meta.title}}</li>
                        <template v-for="child in menu.children" >
                            <li class="li-title_2" @click="title2Click($event,resolvePath(topPath,menu.path,child.path))">{{child.meta.title}}</li>
                        </template>
                    </template>
                </ul>

                <!-- 商品滚播 -->
                <Broadcast></Broadcast>
            </el-aside>
            <el-main>
                <router-view>

                </router-view>
             </el-main>
        </el-container>
    </div>
</template>

<script  type="text/ecmascript-6">
    import path from 'path'
    import {mapGetters} from 'vuex'
    import {getShopList} from '@/api/plat/class'
    import Broadcast from '@/components/common/Broadcast'

    export default {
        name: "orderIndex",
        components:{
            Broadcast
        },
        data() {
            return {
                topPath:''
            }
        },
        computed:{
                ...mapGetters(['permission_routes']),
            leftMenu() {
                if(this.permission_routes[0] && this.permission_routes[0].children){
                    let menus = this.permission_routes[0].children;
                    let matched = this.$route.matched.filter(item => item.meta && item.meta.title);
                    let munuList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
                    let order = menus.filter(item => item.path == munuList[0].path);
                    this.topPath = order[0].path;
                    return order[0].children;
                }

            }
        },
        created() {
            this.getDicts("order_status").then(response => {
                this.$store.commit('SET_ORDERSTATUS',response.data)
            });
        },
        methods: {
            title2Click(e,url){
                let _dom = document.querySelector('.li-title_2.title-2-select');
                if (_dom) {
                    _dom.classList.toggle('title-2-select');//当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
                }
                e.target.classList.toggle('title-2-select');
                this.$router.push(url);
            },
            resolvePath(firstPath, secondPath, thirdPath) {
                return path.resolve(firstPath, secondPath,thirdPath)
            },
        },
        mounted() {
            let that = this;
            $.ajax({
                url:process.env.BASE_URL + 'exportTemplate.json',
                method:'get',
                success:function (res) {
                    that.$store.dispatch('setBaseTemplate',res.baseTemplate);
                }
            })
        },
    }
</script>

<style scoped>
    @import '../../assets/css/order.css';
    .order_index{
        width: 100%;
    }
    .left_url_tab{
        border: 1px solid #ccc;
        font-size: 13px;
    }
    .left_url_tab li:not(:last-child){
        list-style: none;

    }

    .li-title_1{
        height: 32px;
        line-height: 32px;
        background-color: #c1c1c154;
        vertical-align: top;
        padding-left: 5px;
        font-weight: 600;
    }
    .li-title_2{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 20px;
        border-bottom: 1px solid #ccc;
    }
    .li-title_3{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 40px;
    }
    .li-title_2:hover{
        background-color: #409eff;
        color: white;
        cursor: pointer;
    }
    .title-2-select{
        background-color: #409eff;
        color: white;
        cursor: pointer;
    }
    .li-help a{
        text-decoration: none;
        color: #409eff;
    }

</style>
